import { render, staticRenderFns } from "./ProductChangeLogsTable.vue?vue&type=template&id=762b7258&scoped=true"
import script from "./ProductChangeLogsTable.vue?vue&type=script&lang=js"
export * from "./ProductChangeLogsTable.vue?vue&type=script&lang=js"
import style0 from "./ProductChangeLogsTable.vue?vue&type=style&index=0&id=762b7258&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762b7258",
  null
  
)

export default component.exports